interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'dark' | 'light';
}

const sizes = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-12',
};

export function Logo({ size = 'md', variant = 'dark' }: LogoProps) {
  // Use dark logo on light backgrounds, light logo on dark backgrounds
  const logoSrc = variant === 'dark' ? '/spacelogodark.png' : '/spacelogo.png';

  return (
    <img
      src={logoSrc}
      alt="Space01"
      className={`${sizes[size]} w-auto`}
    />
  );
}
